// controller
import useGetData from "../../../hook/getData";
import { GetWishList } from "../../../services/panel/wishList/wishList";
import { Link } from "react-router";
import { IconShoppingBag } from "@tabler/icons-react";
import Heart from "../../../components/heart/heart";
import { splitNumber } from "../../../features/splitNumber/splitNumber";

const WishList = () => {
    const { data: list } = useGetData(["wishList"], GetWishList);
    console.log(list)
    return (
        <>
            <h6 className="fw-bold mb-0">علاقه مندی ها</h6>
            <hr />
            <div className="row gy-3">
                {list?.map((comment: any, index: number) => (
                    <div className="col-md-4">
                        <div className="card new-product-card border-0 rounded rounded-4 shadow">
                            <div className=" rounded rounded-4 p-3">
                                <span className="badge bg-white text-dark icon shadow">
                                    {comment?.product?.quantity_check?.price ? (
                                        <span className="card-title price font-medium-lg">محصولات</span>
                                    ) : (
                                        <span className="card-title text-danger fw-bold price text-danger  font-medium-lg">نا موجود</span>
                                    )}
                                </span>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to={`/products/detail/${comment?.product?.slug}`} className="text-decoration-none">
                                        <img src={`https://dash.akband.com/uploads/files/products/images/${comment?.product?.primary_image}`} alt="product" />
                                    </Link>
                                </div>
                                <div className="color-place icon">
                                    <div className="like-place shadow">
                                        <Heart id={comment?.product?.id} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-body mt-1">
                                <Link to={`/products/detail/${comment?.product?.slug}`} className="text-decoration-none">
                                    <div className="d-flex justify-content-between align-items-center" style={{ height: '40px' }}>
                                        <span className="text-dark w-100 text-line fw-bold font-medium-lg mb-0">
                                            {comment?.product?.name}
                                        </span>
                                    </div>
                                    <hr />
                                    <div className="d-flex justify-content-between">
                                        <IconShoppingBag className="align-middle text-site" />
                                        {comment?.product?.quantity_check?.price ? (
                                            <span className="card-title price font-medium-lg">{splitNumber(comment?.product?.quantity_check?.price)}  تومان</span>
                                        ) : (
                                            <span className="card-title text-danger fw-bold price font-medium-lg">نا موجود</span>
                                        )}
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}

            </div>

        </>
    )
}
export default WishList;